<div id="content" class="allcp-form" ng-controller="RouteController" ng-init="getList()">
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
	<div class="panel-body">
		<div class="table-responsive" ng-if="data.orders.data.length > 0">
			<div id="scrollable-area">
				<table class="table table-hover tc-checkbox-1" fixed-table-headers="scrollable-areas">
					<thead>
						<tr class="bg-light">
							<th>
							</th>
							<th style="min-width: 150px;">
							</th>
							<th>Phone</th>
							<th style="min-width: 150px;">
								Order Id
							</th>
							<th>
								Created
								<a ng-click="sort('created_at','desc')"
									ng-if="filterData.sort == 'asc' || !filterData.field">
									<i class="fa fa-sort-alpha-desc"></i>
								</a>
								<a ng-click="sort('created_at','asc')" ng-if="filterData.sort == 'desc'">
									<i class="fa fa-sort-alpha-asc"></i>
								</a>
							</th>
							<th>
								Delivery
								<a ng-click="sort('scheduled_time','desc')"
									ng-if="filterData.sort == 'asc' || !filterData.field">
									<i class="fa fa-sort-alpha-desc"></i>
								</a>
								<a ng-click="sort('scheduled_time','asc')" ng-if="filterData.sort == 'desc'">
									<i class="fa fa-sort-alpha-asc"></i>
								</a>
							</th>
							<th>Piece</th>
							<th>Weight</th>
							<th>Details</th>

							<th>
								Status
								<a ng-click="sort('status','desc')"
									ng-if="filterData.sort == 'asc' || !filterData.field">
									<i class="fa fa-sort-alpha-desc"></i>
								</a>
								<a ng-click="sort('status','asc')" ng-if="filterData.sort == 'desc'">
									<i class="fa fa-sort-alpha-asc"></i>
								</a>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr dir-paginate="item in data.orders.data | itemsPerPage: filterData.paginate"
							total-items="data.orders.total" current-page="data.orders.current_page"
							ng-class="{'checked': selectedItems.indexOf(item.id) > -1}">
							<td class="clickable-row">
								<label class="option block mn" ng-if="item.status == 0 || item.status == null">
									<input type="checkbox" ng-click="addSelectedItem(item.id)"
										ng-checked="selectedItems.indexOf(item.id) > -1 || master"
										id="checkboxDefault-{{item.id}}">
									<span class="checkbox mn"></span>
								</label>
							</td>
							<td class="clickable-row" ng-click="getOrderDetails(item)">
								<div class="avatar-container">
									<div class="avatar-img">
										{{ item.location.name.split(' ')[0][0] }}{{ item.location.name.split(' ')[1][0] }}
									</div>
									<div class="avatar-detail">
										<strong style="font-weight:bold">{{ item.location.name }}</strong>
										{{ item.location.email }}
									</div>
								</div>
							</td>
							<td class="clickable-row" ng-click="getOrderDetails(item)">
								{{ item.location.phone_number | tel }}
							</td>

							<td class="clickable-row" ng-click="getOrderDetails(item)">
								{{item.unique}}
							</td>

							<td class="clickable-row" ng-click="getOrderDetails(item)">
								{{ item.created_at | amDateFormat:'MM/DD/YYYY' }} </td>

							<td class="clickable-row" ng-click="getOrderDetails(item)">
								{{ item.scheduled_time | amDateFormat:'MM/DD/YYYY' }}
							</td>
							<td class="clickable-row mw200" ng-click="getOrderDetails(item)">{{ item.piece }}</td>
							<td class="clickable-row mw200" ng-click="getOrderDetails(item)">{{ item.weight }}</td>
							<td class="clickable-row mw200" ng-click="getOrderDetails(item)">
								{{ item.name | cut:true:40:' ...' }}</td>

							<td class="clickable-row" ng-click="getOrderDetails(item)">
								<div class="avatar-container" ng-if="item.status">
									<div class="avatar-detail">
										<span ng-if="item.status"
											ng-style="{'color': item.status.color }">{{ item.status.name }}</span>
										<span
											ng-if="item.status && item.status.value == 'last' && item.estimated_delivery">ETA
											{{ item.estimated_delivery | amDateFormat:'hh:mm A' }}</span>
										<span
											ng-if="item.status && item.status.value == 'last' && !item.estimated_delivery">Calculating...</span>
									</div>
								</div>
								<span ng-if="!item.status" class="pl15">Created</span>
							</td>

						</tr>
					</tbody>
				</table>
			</div>
			<div class="paginate-area">
				<div class="row">
					<div class="col-11">
						<dir-pagination-controls boundary-links="true" on-page-change="getPage(newPageNumber)"
							template-url="dirPagination.tpl.html" class="pagination-lg pagination pull-right pr10">
						</dir-pagination-controls>
					</div>
					<div class="col-1 pl0">
						<select class="form-control" ng-model="filterData.paginate" ng-change="filter()"
							ng-options="pageSize for pageSize in pageSizes">
						</select>
					</div>
				</div>
			</div>
		</div>

		<div class="text-center mt50" ng-if="isEmpty">
			<div ng-if="false">
				<img src="img/empty_page_orange.svg" alt="" width="400px">
				<br>
				<h3 style="font-size: 48px;font-weight: 800;">No orders yet</h3>
			</div>
			<h3 style="font-size: 32px;font-weight: 400;">
				None of your customers or orders matched this search. <br> Please try another search ...
			</h3>
		</div>

	</div>
	<!-- Delete Orders -->
	<div class="modal info-box fade" id="deleteOrdersModal" tabindex="-1" role="dialog" aria-labelledby="deleteOrdersModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content p25">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <p class="pb25">Are you sure you want to delete {{ selectedItems.length == 1 ? 'this' : selectedItems.length }} order{{ selectedItems.length > 1 ? 's' : '' }}?</p>
                        </div>
                    </div>

                    <div class="">
                        <button type="submit" class="btn pull-right btn-danger" ng-click="deleteOrders(false)">
                            Delete
                        </button>
                        <button type="button" class="btn pull-left btn-default" data-dismiss="modal" data-toggle="modal">Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
	</div>
</div>